import { createFileRoute } from '@tanstack/react-router';
import { JourneysWorkflowHandoff } from '@/pages/workspaces/automations/[campaignId]/workflow/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/**
 * The legacy `/journeys/campaigns/:campaignId/setup/workflow/actions` URL — the Ember
 * setup-flow canvas. Flag off it renders the embedded host; flag on it forwards to the migrated
 * URL.
 *
 * `appBundle` belongs here and not on the migrated twin: this URL keeps the `journeys` segment,
 * so the resolver's bundle-aware branch can rebuild the target from the bundle prefix when the
 * `/workspaces/last` sentinel needs resolving.
 */
function JourneysCampaignsSetupWorkflowActionsRoute() {
  const { campaignId } = Route.useParams();

  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysWorkflowHandoff campaignId={campaignId} />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/setup/workflow/actions',
)({
  component: JourneysCampaignsSetupWorkflowActionsRoute,
});
